import { render } from "./IBNodeList.vue?vue&type=template&id=866f5680"
import script from "./IBNodeList.vue?vue&type=script&lang=js"
export * from "./IBNodeList.vue?vue&type=script&lang=js"
script.render = render

export default script